import { address, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const CustomerApplicationOrigination = gql`
  query CustomerApplicationOrigination {
    __typename
    applications {
      id
      __typename
      ... on LendingApplication {
        amount {
          ...money
        }
        annualIncome {
          ...money
        }
        employerName
        employmentTypeId
        housingTypeId
        housingMonthlyPayment {
          ...money
          __typename
        }
        isMilitaryService
        loanPurposeId
        offerDetailsId
      }
      ... on BankApplication {
        id
        firstName
        lastName
        dateOfBirth
        address {
          ...address
          __typename
        }
        mailingAddress {
          ...address
          __typename
        }
        email {
          address
          verified
        }
        countryOfCitizenship
        occupation
        productSelections
        status
        eligibleForReapply
      }
    }
  }
  ${address}
  ${money}
`;
export default CustomerApplicationOrigination;
